import { useState } from 'react'
import { View } from 'react-native'
import { SessionSummary } from '@/src/dal/session-dal'

import { toDateLabel } from '../../utils/map-backend-sessions-to-voice-assessment-statistics'
import { VoiceAssessmentAccordionRow } from './VoiceAssessmentAccordionRow'
import { VoiceAssessmentLatestAnalyzingCard } from './VoiceAssessmentLatestAnalyzingCard'

function defaultExpandedId(entries: SessionSummary[]): number | null {
  const [first] = entries
  if (first == null) {
    return null
  }
  if (first.status === 'Completed') {
    return first.id
  }
  return null
}

interface VoiceAssessmentHistoryAccordionProps {
  entries: SessionSummary[]
}

export function VoiceAssessmentHistoryAccordion({
  entries,
}: VoiceAssessmentHistoryAccordionProps) {
  const [expandedId, setExpandedId] = useState<number | null>(() =>
    defaultExpandedId(entries),
  )

  return (
    <View>
      {entries.map((entry, index) => {
        if (entry.status === 'PendingAnalysis') {
          return (
            <VoiceAssessmentLatestAnalyzingCard
              key={entry.id}
              dateLabel={toDateLabel(entry.created)}
              isLatest={index === 0}
            />
          )
        }

        return (
          <VoiceAssessmentAccordionRow
            key={entry.id}
            entry={entry}
            isLatest={index === 0}
            expanded={expandedId === entry.id}
            onToggle={() => {
              setExpandedId((current) =>
                current === entry.id ? null : entry.id,
              )
            }}
          />
        )
      })}
    </View>
  )
}
